export default __webpack_public_path__ + "static/media/down_metric.262d750a.svg";